import Dress1 from "../assets/dress1.jpeg";
import Dress2 from "../assets/dress18.jpeg";
import Dress3 from "../assets/dress16.jpeg";
import Dress4 from "../assets/dress17.jpeg";
import Dress5 from "../assets/dress11.jpeg";
import Dress6 from "../assets/dress15.jpeg";
import Dress7 from "../assets/dress13.jpeg";
import Dress8 from "../assets/dress14.jpeg";
import Dress9 from "../assets/dress2.jpeg";
import Dress10 from "../assets/dress3.jpeg";
import Dress11 from "../assets/dress4.jpeg";
import Dress12 from "../assets/dress5.jpeg";
import Dress13 from "../assets/dress6.jpeg";
import Dress14 from "../assets/dress7.jpeg";
import Dress15 from "../assets/dress8.jpeg";
import Dress16 from "../assets/dress9.jpeg";
import Dress17 from "../assets/dress10.jpeg";
import Dress18 from "../assets/dress12.jpeg";
import Skirt1 from "../assets/skirt1.jpeg";
import Skirt2 from "../assets/skirt2.jpeg";
import Skirt3 from "../assets/skirt3.jpeg";
import Skirt4 from "../assets/skirt4.jpeg";
import Skirt5 from "../assets/skirt5.jpeg";
import Skirt6 from "../assets/skirt6.jpeg";
import Skirt7 from "../assets/skirt7.jpeg";
import Skirt8 from "../assets/skirt8.jpeg";
import Skirt9 from "../assets/skirt9.jpeg";
import Skirt10 from "../assets/skirt10.jpeg";
import Purse1 from "../assets/purse1.jpeg";
import Purse2 from "../assets/purse2.jpeg";
import Purse3 from "../assets/purse3.jpeg";
import Purse4 from "../assets/purse4.jpeg";
import Purse5 from "../assets/purse5.jpeg";
import Top1 from "../assets/top1.jpeg";
import Top2 from "../assets/top2.jpeg";
import Top3 from "../assets/top3.jpeg";
import Top4 from "../assets/top4.jpeg";
import Top5 from "../assets/top5.jpeg";

export const PRODUCT = [
  {
    id: 1,
    productName: "Sassy Black dress",
    price: 200,
    productImage: Dress1,
    category: "dress",
    colour: "Black",
  },
  {
    id: 2,
    productName: "Elegent Rose gold",
    price: 250,
    productImage: Dress2,
    category: "dress",
    colour: "Pink",
  },
  {
    id: 3,
    productName: "Vencisya",
    price: 300,
    productImage: Dress3,
    category: "dress",
    colour: "White",
  },
  {
    id: 4,
    productName: "Dua te rose",
    price: 290,
    productImage: Dress4,
    category: "dress",
    colour: "Grey",
  },
  {
    id: 5,
    productName: "Off shoulder temoda",
    price: 400,
    productImage: Dress5,
    category: "dress",
    colour: "Brown",
  },
  {
    id: 6,
    productName: "Classy gold",
    price: 608,
    productImage: Dress6,
    category: "dress",
    colour: "Gold",
  },
  {
    id: 7,
    productName: "Senoria",
    price: 556,
    productImage: Dress7,
    category: "dress",
    colour: "Red",
  },
  {
    id: 8,
    productName: "Gorgia",
    price: 580,
    productImage: Dress8,
    category: "dress",
    colour: "Red",
  },
  {
    id: 9,
    productName: "cenara",
    price: 356,
    productImage: Dress9,
    category: "dress",
    colour: "White",
  },
  {
    id: 10,
    productName: "sopera",
    price: 6899,
    productImage: Dress10,
    category: "dress",
    colour: "Green",
  },
  {
    id: 11,
    productName: "seline",
    price: 657,
    productImage: Dress11,
    category: "dress",
    colour: "White",
  },
  {
    id: 12,
    productName: "tenor",
    price: 6777,
    productImage: Dress12,
    category: "dress",
    colour: "Black",
  },
  {
    id: 13,
    productName: "cape",
    price: 957,
    productImage: Dress13,
    category: "dress",
    colour: "Rose",
  },
  {
    id: 14,
    productName: "YE",
    price: 879,
    productImage: Dress14,
    category: "dress",
    colour: "Red",
  },
  {
    id: 15,
    productName: "sophira",
    price: 618,
    productImage: Dress15,
    category: "dress",
    colour: "Blue",
  },
  {
    id: 16,
    productName: "canara",
    price: 157,
    productImage: Dress16,
    category: "dress",
    colour: "Blue",
  },
  {
    id: 17,
    productName: "cape",
    price: 857,
    productImage: Dress17,
    category: "dress",
    colour: "Gold",
  },
  {
    id: 18,
    productName: "gorgia",
    price: 987,
    productImage: Dress18,
    category: "dress",
    colour: "Purple",
  },
  {
    id: 19,
    productName: "Button up",
    price: 200,
    productImage: Skirt1,
    category: "skirt",
    colour: "White",
  },
  {
    id: 20,
    productName: "Laces",
    price: 240,
    productImage: Skirt2,
    category: "skirt",
    colour: "White",
  },

  {
    id: 22,
    productName: "Cross over",
    price: 2700,
    productImage: Skirt3,
    category: "skirt",
    colour: "Green",
  },
  {
    id: 22,
    productName: "slay in black",
    price: 850,
    productImage: Skirt4,
    category: "skirt",
    colour: "Black",
  },
  {
    id: 23,
    productName: "sopera",
    price: 500,
    productImage: Skirt5,
    category: "skirt",
    colour: "Grey",
  },
  {
    id: 25,
    productName: "Benansiya",
    price: 950,
    productImage: Skirt6,
    category: "skirt",
    colour: "Green",
  },
  {
    id: 26,
    productName: "cenara",
    price: 760,
    productImage: Skirt7,
    category: "skirt",
    colour: "Brown",
  },
  {
    id: 27,
    productName: "velora",
    price: 700,
    productImage: Skirt8,
    category: "skirt",
    colour: "Black",
  },
  {
    id: 28,
    productName: "sopera",
    price: 200,
    productImage: Skirt9,
    category: "skirt",
    colour: "Pink",
  },
  {
    id: 29,
    productName: "belt up",
    price: 209,
    productImage: Skirt10,
    category: "skirt",
    colour: "Brown",
  },
  {
    id: 30,
    productName: "Deor ",
    price: 2069,
    productImage: Purse1,
    category: "purse",
    colour: "Pink",
  },
  {
    id: 31,
    productName: "Capern ",
    price: 409,
    productImage: Purse2,
    category: "purse",
    colour: "Blue",
  },
  {
    id: 32,
    productName: " Verna",
    price: 609,
    productImage: Purse3,
    category: "purse",
    colour: "Black",
  },
  {
    id: 33,
    productName: "YRdna ",
    price: 8909,
    productImage: Purse4,
    category: "purse",
    colour: "Black",
  },
  {
    id: 34,
    productName: " Deor",
    price: 345,
    productImage: Purse5,
    category: "purse",
    colour: "Black",
  },
  {
    id: 35,
    productName: "Slayse ",
    price: 345,
    productImage: Top1,
    category: "top",
    colour: "Brown",
  },
  {
    id: 36,
    productName: "Yesra ",
    price: 995,
    productImage: Top2,
    category: "top",
    colour: "Yellow",
  },
  {
    id: 37,
    productName: "Sepota ",
    price: 904,
    productImage: Top3,
    category: "top",
    colour: "White",
  },
  {
    id: 38,
    productName: " Yesra",
    price: 395,
    productImage: Top4,
    category: "top",
    colour: "Green",
  },
  {
    id: 39,
    productName: "POGO ",
    price: 3945,
    productImage: Top5,
    category: "top",
    colour: "White",
  },
];
